import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { updateIdentities } from '../../Lib/redux/slices/userIdentities';
import { generateUUID } from '../../Utils/utils';

/**
 * Component responsible for managing the different user identities, among them
 * the internally generated visitorId, which is a unique uuid responsible for
 * tracking a single customer session on the form.
 * @component
 * @returns {null} - This component does not render any UI elements.
 */
const IdentitiesManager = () => {
  const dispatch = useDispatch();
  const { visitorId } = useSelector((store) => store.userIdentities);
  useEffect(() => {
    if (!visitorId) {
      /*
       * Sentry is responsible for generating the visitorId (refer to
       * sentry.client.config.js for details). This component takes care
       * of populating the store with it.
       */
      const newVisitorId =
        process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true' &&
        window.__private__?.visitorId
          ? window.__private__.visitorId
          : generateUUID();
      dispatch(updateIdentities({ visitorId: newVisitorId }));
    }
  }, [visitorId]);

  return null;
};

export default IdentitiesManager;
